import React, { useContext, useEffect, useState } from 'react';
import { Redirect } from "react-router-dom";
import { makeStyles } from '@material-ui/core/styles';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import Link from '@material-ui/core/Link';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import { AppContext } from "store/AppContext";
import bgImage from "assets/images/vote-1.jpg";
import Cookies from 'universal-cookie';
import jwtDecode from 'jwt-decode';
import { getIsTokenExpired } from 'common/services/authService';
import crypto from 'crypto'
function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {'© '}
      <Link color="inherit" href="https://skra.is" target="_blank" rel="noopener">
        Þjóðskrá Íslands
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

const useStyles = makeStyles(theme => ({
  root: {
    height: '100vh',
  },
  image: {
    backgroundImage: `url(${bgImage})`,
    backgroundRepeat: 'no-repeat',
    backgroundColor:
      theme.palette.type === 'dark' ? theme.palette.grey[900] : theme.palette.grey[50],
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  },
  paper: {
    margin: theme.spacing(12, 4),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  submit: {
    margin: theme.spacing(5, 0, 0),
  },
  form: {
    width: '100%',
  }
}));

function sha256(buffer) {
    return crypto.createHash('sha256').update(buffer).digest();
}
function base64URLEncode(str) {
    return str.toString('base64')
        .replace(/\+/g, '-')
        .replace(/\//g, '_')
        .replace(/=/g, '');
}

const Innskraning = (props) => {
    const classes = useStyles();
    const context = useContext(AppContext);
    const cookies = new Cookies();
    const idtoken = cookies.get('jwt_token');

    useEffect(() => {
       
      if (idtoken !== undefined) {
          //const jwtDecoded = jwtDecode(accesstoken);
          const idDecoded = jwtDecode(idtoken);
          // On refresh, logout if token is expired
        if (getIsTokenExpired(idtoken)) {
              context.isLoggedIn.set(false);
              cookies.remove('id_token');
          } else {
              context.user.set((prevState) => {
                  return { ...prevState, jwt: idtoken, details: idDecoded };
              });

              context.isLoggedIn.set(true);
          }
      }
      else {


          console.warn('No accesstoken cookie found');
       }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Redirect flow after login
  if (context.isLoggedIn.get) {
      if (props.location.state !== undefined) {
          return <Redirect to={props.location.state.from} />;
      }
      else { 
      return <Redirect to="/" />;
    }
  }

  return (
    <Grid container component="main" className={classes.root}>
      <CssBaseline />
      <Grid item xs={false} sm={4} md={7} className={classes.image} />
      <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
        <div className={classes.paper}>
          <Typography
            component="h1"
            variant="h4"
            style={{ marginBottom: "24px" }}
          >
            Kosningar utan kjörfundar
          </Typography>
          <Avatar className={classes.avatar}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography
            component="h1"
            variant="h5"
            style={{ marginBottom: "24px" }}
          >
            Innskráning
          </Typography>
          <Typography>
            Innskráning í kerfið notast við rafræn skilríki
          </Typography>
          {/*<Typography>*/}
          {/*  Hægt er að nota annaðhvort <strong>rafræn skilríki í síma</strong>{" "}*/}
          {/*  eða <strong>Íslykil</strong>.*/}
          {/*</Typography>*/}
                 {/* <form
                      method="post"
                      //action={`https://innskraning.island.is/?id=${process.env.REACT_APP_ISLANDIS_ID}`}

                      //action={"https://identity-server.dev01.devland.is/connect/authorize"}
                      action={"https://localhost/api/auth/login" }
                      /*
                      Example:
                      https://docs.devland.is/products/auth/configuration#example-authentication


                      with these query parameters:

                            client_id=@skra.is/utankjorfundarkerfi   Island_is_ID from appsettings.json

                            redirect_uri=https://app.myorg.is/oauth/callback
                                           https://localhost:44305/api/auth/callback
                            response_type=code

                            scope=openid profile offline_access @myorg.is/documents:read @myorg.is/documents:write

                            state={SOME_STATE}
                            code_challenge={CODE_CHALLENGE}
                            code_challenge_method=S256
                            response_mode=query
                      /
                //action="https://localhost:44305/api/auth/thorsten"
                      //action={https://localhost:44305/api/auth/GetislandIsTokenAsync}

                      /*headers={
                          "client_id" : { process.env.ReactApp_IslandIsClientId },
                          "redirect_uri" : { process.env.ReactApp_IslandIsRedirectUrl }
                      }/

            className={classes.form}
          >
            <input type="hidden" name="qaa" value="2" />
            <input type="hidden" name="client_id" value={process.env.REACT_APP_ISLANDIS_ID} />
            <input type="hidden" name="redirect_uri" value={process.env.REACT_APP_REDIRECT_URI/*  "http://localhost:3000/callback" /} />
            <input type="hidden" name="response_type" value="code" />
            <input type="hidden" name="code_challenge_method" value="S256" />
            <input type="hidden" name="scope" value="openid profile" />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              size="large"
              className={classes.submit}
            >
              Áfram á Ísland.is
            </Button> 
          </form> */}
          <Button href="/api/auth/login" fullWidth variant="contained" color="primary" size="large" className={classes.submit}>
            Áfram á Ísland.is
          </Button>
        </div>
        <Copyright />
      </Grid>
    </Grid>
  );
}

export default Innskraning;